export default {
  /**
   * 指定した範囲の整数の配列を取得する
   *
   * @param {Number} start 最小値
   * @param {Number} end 最大値
   * @returns {Array} 整数の配列
   */
  range(start, end) {
    if (start >= end) {
      return [];
    }
    return [...Array(end - (start - 1)).keys()].map((i) => i + start);
  }
};
